import axios from "axios";
import { mapCertification } from "api/competencyManagement/mappers";
import { MyCertificationInterface } from "module/certification/types";

const getCertificationDetails = async (
  certificationId: number
): Promise<MyCertificationInterface> => {
  const response = await axios.get(`/api/certifications/${certificationId}`);
  return mapCertification(response.data);
};

export default getCertificationDetails;
